import React, { useEffect, useState } from 'react';
import {
  MainButton,
  MainLink,
  Subtitle,
  TextRegular,
  Title,
} from '../../styles/GlobalStyledComponents';
import { UnknowErrorImage } from './UnknownErrorStyledComponent';
import PostMessageService from '../../services/PostMessage';

import ErrorImg from '../../assets/images/error/unknow-error.svg';
import ViewModeService from '../../services/ViewMode';
import { useMerchant } from '../../contexts/MerchantContext';
import { useCreditProposalResult } from '../../contexts/CreditProposalResultContext';
import AnalyticsHelper from '../../utils/analyticsHelper';
import AnalyticsService from '../../services/Analytics';
import { useLocation } from 'react-router-dom';

interface UnknownErrorProps {
  loadingEvent: (data: boolean) => void;
}

export const UnknownError: React.FC<UnknownErrorProps> = ({ loadingEvent }) => {
  const { creditProposalResult } = useCreditProposalResult();
  const { isPostDataMessages } = useMerchant();

  const location = useLocation();
  const [isApp, setisApp] = useState<boolean>(false);
  const [device, setDevice] = useState<string | null>(null);

  const handleCancel = () => {
    if (isApp && device === 'android') {
      window.location.href = 'peppermerchants://home';
    } else {
      PostMessageService.closeCEX();
    }
  };

  useEffect(() => {
    const step_number = AnalyticsHelper.getStepLocation(location.pathname);
    AnalyticsService.sendEventKo(step_number);
    loadingEvent(false);
  }, [loadingEvent]);

  useEffect(() => {
    setisApp(ViewModeService.getViewMode() === 'APP' ? true : false);
    setDevice(ViewModeService.getDevice());
  }, [isApp, device]);

  useEffect(() => {
    if (isPostDataMessages) {
      PostMessageService.FinancingFailed(
        creditProposalResult?.credit_proposal_id
      );
    }
  }, []);

  return (
    <>
      <Title id="unknown-error-title">¡Ups! Algo ha ido mal...</Title>
      <Subtitle>
        Por favor, vuelve a intentarlo
      </Subtitle>
      <UnknowErrorImage src={ErrorImg}></UnknowErrorImage>
      {isApp && device === 'ios' ? (
        <MainLink href="peppermerchants://home">Volver</MainLink>
      ) : (
        <MainButton id="unknown-error-return-btn" onClick={handleCancel}>
          Volver
        </MainButton>
      )}
    </>
  );
};
